'use strict';
var toIntegerOrInfinity = require('../internals/to-integer-or-Infinity');
var min = Math.min;

/**
 * 根据传入的参数返回一个值
 * 如果参数大于0，则返回参数和0x1FFFFFFFFFFFFF（2的53次方减1）中较小的值
 * 如果参数小于等于0，则返回0
 * @param {number} argument 要进行比较的参数
 * @returns {number} 根据条件返回的值
 */
module.exports = function(argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
